import { createReducer } from '@reduxjs/toolkit';
import { ArrowType } from '@rapid-recovery-agency-inc/insightt-shared';

import {
  fetchPeopleWorkingCountAction,
  fetchPeopleWorkingDataAction,
  getRepos,
  getReposWithPrevious,
  getSpotted,
  getSpottedVehiclesWithPrevious,
} from './actions';
import { AdminBasicDashboardState } from './types';

export const INITIAL_BASIC_DASHBOARD_ADMIN_STATE: AdminBasicDashboardState = {
  repossessionsLoading: false,
  repossessionsCountLoading: false,
  spottedVehiclesLoading: false,
  spottedVehiclesCountLoading: false,
  totalLPRScansLoading: false,
  peopleWorkingLoading: false,
  peopleWorkingCountLoading: false,
  repossessionsCount: {
    currentCount: 0,
    previousCount: 0,
    previousTitle: '',
  },
  repossessions: [],
  spottedVehiclesCount: {
    currentCount: 0,
    previousCount: 0,
    previousTitle: '',
  },
  spottedVehicles: [],
  unitsPendingRepoCount: {
    currentCount: 0,
    previousCount: 0,
    previousTitle: '',
  },
  unitsPendingRepo: [],
  totalLPRScans: {
    currentCount: 0,
    previousCount: 0,
    previousTitle: '',
  },
  peopleWorking: {
    list: [],
  },
  peopleWorkingCount: {
    arrow: ArrowType.NEUTRAL,
    percent: 0,
    previousCount: 0,
    allCount: 0,
    previousTitle: '',
    recoveryAgentsCount: '0',
    cameraCarsCount: '0',
    spottersCount: '0',
    othersCount: '0',
  },
  assignedToMe: {
    obstructed: 0,
    accessible: 0,
    all: 0,
  },
  rhlCount: 0,
  rhlCountLoading: false,
};

export const basicDashboardAdminReducer = createReducer(INITIAL_BASIC_DASHBOARD_ADMIN_STATE, (builder) => {
  builder
    .addCase(getRepos.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        repossessionsLoading: false,
      };
    })
    .addCase(getRepos.pending, (state) => {
      return {
        ...state,
        repossessionsLoading: true,
      };
    })
    .addCase(getRepos.rejected, (state) => {
      return {
        ...state,
        repossessions: INITIAL_BASIC_DASHBOARD_ADMIN_STATE.repossessions,
        repossessionsLoading: false,
      };
    })
    .addCase(getReposWithPrevious.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        repossessionsCountLoading: false,
      };
    })
    .addCase(getReposWithPrevious.pending, (state) => {
      return {
        ...state,
        repossessionsCountLoading: true,
      };
    })
    .addCase(getReposWithPrevious.rejected, (state) => {
      return {
        ...state,
        repossessionsCount: INITIAL_BASIC_DASHBOARD_ADMIN_STATE.repossessionsCount,
        repossessionsCountLoading: false,
      };
    })
    .addCase(getSpotted.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        spottedVehiclesLoading: false,
      };
    })
    .addCase(getSpotted.pending, (state) => {
      return {
        ...state,
        spottedVehiclesLoading: true,
      };
    })
    .addCase(getSpotted.rejected, (state) => {
      return {
        ...state,
        spottedVehicles: INITIAL_BASIC_DASHBOARD_ADMIN_STATE.spottedVehicles,
        spottedVehiclesLoading: false,
      };
    })
    .addCase(getSpottedVehiclesWithPrevious.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
        spottedVehiclesCountLoading: false,
      };
    })
    .addCase(getSpottedVehiclesWithPrevious.pending, (state) => {
      return {
        ...state,
        spottedVehiclesCountLoading: true,
      };
    })
    .addCase(getSpottedVehiclesWithPrevious.rejected, (state) => {
      return {
        ...state,
        spottedVehiclesCount: INITIAL_BASIC_DASHBOARD_ADMIN_STATE.spottedVehiclesCount,
        unitsPendingRepoCount: INITIAL_BASIC_DASHBOARD_ADMIN_STATE.unitsPendingRepoCount,
        spottedVehiclesCountLoading: false,
      };
    })
    .addCase(fetchPeopleWorkingCountAction.rejected, (state, action) => ({
      ...state,
      peopleWorkingCount: action.meta?.arg?.isSilent
        ? state.peopleWorkingCount
        : INITIAL_BASIC_DASHBOARD_ADMIN_STATE.peopleWorkingCount,
      peopleWorkingCountLoading: false,
    }))
    .addCase(fetchPeopleWorkingCountAction.pending, (state, action) => ({
      ...state,
      peopleWorkingCountLoading: action.meta?.arg?.isSilent ? state.peopleWorkingCountLoading : true,
    }))
    .addCase(fetchPeopleWorkingCountAction.fulfilled, (state, action) => ({
      ...state,
      ...action.payload,
      peopleWorkingCountLoading: false,
    }))
    .addCase(fetchPeopleWorkingDataAction.fulfilled, (state, action) => ({
      ...state,
      ...action.payload,
      peopleWorkingLoading: false,
    }))
    .addCase(fetchPeopleWorkingDataAction.pending, (state, action) => ({
      ...state,
      peopleWorkingLoading: action.meta?.arg?.isSilent ? state.peopleWorkingLoading : true,
    }))
    .addCase(fetchPeopleWorkingDataAction.rejected, (state, action) => ({
      ...state,
      peopleWorking: action.meta?.arg?.isSilent
        ? state.peopleWorking
        : INITIAL_BASIC_DASHBOARD_ADMIN_STATE.peopleWorking,
      peopleWorkingLoading: false,
    }))
    .addDefaultCase((state) => state);
});
